import React from 'react';
import { StickyTopBar } from '../components/StickyTopBar';
import { HeroSection } from '../components/HeroSection';
import { PainPointSection } from '../components/PainPointSection';
import { SolutionSection } from '../components/SolutionSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { BonusSection } from '../components/BonusSection';
import { PricingSection } from '../components/PricingSection';
import { FinalCTASection } from '../components/FinalCTASection';
import { Footer } from '../components/Footer';
import { RecentPurchaseToast } from '../components/RecentPurchaseToast';
export function HomePage() {
  return <div className="min-h-screen bg-light-gray flex flex-col font-body" data-id="element-276">
      <StickyTopBar data-id="element-277" />
      <RecentPurchaseToast data-id="element-278" />
      <main className="flex-grow pt-[40px] md:pt-[44px]" data-id="element-279">
        <HeroSection data-id="element-280" />
        <TestimonialsSection data-id="element-281" />
        <PainPointSection data-id="element-282" />
        <SolutionSection data-id="element-283" />
        <BonusSection data-id="element-284" />
        <PricingSection data-id="element-285" />
        <FinalCTASection data-id="element-286" />
      </main>
      <Footer data-id="element-287" />
    </div>;
}